var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
import { OnInit, OnDestroy } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { Store, Select } from '@ngxs/store';
import { Subject, Observable } from 'rxjs';
import { ResetSearchResults, Search, SetSearching } from '../../state/explore.actions';
import { ExploreState } from '../../state/explore.state';
import { takeUntil } from 'rxjs/operators';
import { Location } from '@angular/common';
import { StoryType } from 'src/app/story/models/story-type.enum';
import { GalleryState } from 'src/app/gallery/state/gallery.state';
import { GalleryViewMode } from 'src/app/gallery/models/gallery-view-mode.enum';
import { AuthState } from 'src/app/auth/state/auth/auth.state';
import { DialogActions } from 'src/app/dialogs/state/dialog.actions';
import { BookmarkActionsEnum } from 'src/app/bookmarks/components/bookmark-actions/bookmark-actions.component';
var SearchComponent = /** @class */ (function () {
    function SearchComponent(route, store, location, router) {
        this.route = route;
        this.store = store;
        this.location = location;
        this.router = router;
        this.galleryViewMode = GalleryViewMode;
        this.bookmarkActions = BookmarkActionsEnum;
        this.ngUnsubscribe = new Subject();
    }
    SearchComponent.prototype.ngOnInit = function () {
        var _this = this;
        // search via route param
        this.route.params
            .pipe(takeUntil(this.ngUnsubscribe))
            .subscribe(function (_a) {
            var query = _a.query;
            _this.store.dispatch(new SetSearching(true));
            _this.store.dispatch(new ResetSearchResults());
            _this.store.dispatch(new Search(query));
        });
    };
    SearchComponent.prototype.ngOnDestroy = function () {
        this.store.dispatch(new ResetSearchResults());
        this.store.dispatch(new SetSearching(false));
        this.ngUnsubscribe.next();
        this.ngUnsubscribe.complete();
    };
    SearchComponent.prototype.handleSelectBookmark = function (bookmark) {
        if (!bookmark.premium || this.store.selectSnapshot(AuthState.isPremiumUser)) {
            this.router.navigate(['/view'], { queryParams: { id: bookmark.id, type: StoryType.Module } });
        }
        else {
            this.store.dispatch(new DialogActions.OpenPremiumContent());
        }
    };
    SearchComponent.prototype.goBack = function () {
        this.location.back();
    };
    __decorate([
        Select(ExploreState.getSearchResults),
        __metadata("design:type", Observable)
    ], SearchComponent.prototype, "searchResults$", void 0);
    __decorate([
        Select(ExploreState.getLoading),
        __metadata("design:type", Observable)
    ], SearchComponent.prototype, "loading$", void 0);
    __decorate([
        Select(ExploreState.getSearchQuery),
        __metadata("design:type", Observable)
    ], SearchComponent.prototype, "query$", void 0);
    __decorate([
        Select(GalleryState.getViewMode),
        __metadata("design:type", Observable)
    ], SearchComponent.prototype, "viewMode$", void 0);
    __decorate([
        Select(AuthState.isPremiumUser),
        __metadata("design:type", Observable)
    ], SearchComponent.prototype, "isPremiumUser$", void 0);
    return SearchComponent;
}());
export { SearchComponent };
